import env from '@/core/utils/env'

// 金币中心
export const signUrl = (() => {
  let url = ''
  if (env === 'testing') {
    url = 'https://news.qq.com/signin/v3/index_test.htm'
  } else if (env === 'pre') {
    url = 'https://news.qq.com/signin/v3/index_test_fuyang.htm'
  } else if (env === 'production') {
    url = 'https://news.qq.com/signin/v3/index.htm'
  }

  return url
})()

// 奖品明细
export const signPrizeUrl = (() => {
  return `${signUrl}#/mine`
})()

// 金币明细
export const signCoinUrl = (() => {
  return `${signUrl}#/mine?tabIndex=1`
})()

// 任务中心
export const taskUrl = (() => {
  let url = ''
  if (env === 'testing') {
    url = 'https://news.qq.com/signin/v3/index_test.htm?disabletitlebar=1#/task'
  } else if (env === 'pre') {
    url = 'https://news.qq.com/signin/v3/index.htm?disabletitlebar=1#/task'
  } else if (env === 'production') {
    url = 'https://news.qq.com/signin/v3/index.htm?disabletitlebar=1#/task'
  }

  return url
})()

// 红包中心
export const redpackUrl = (() => {
  let url = ''
  if (env === 'testing') {
    url = 'https://testgh.sparta.html5.qq.com/h5/redcenter/index.html'
  } else if (env === 'pre') {
    url = 'https://pre-gh.prize.qq.com/h5/redcenter/index.html'
  } else if (env === 'production') {
    url = 'https://gh.prize.qq.com/h5/redcenter/index.html'
  }

  return url
})()

// 红包明细
export const redpackDetailUrl = (() => {
  return `${redpackUrl}#/own`
})()

// http server
export const apiUrl = (() => {
  let url = 'http://prize-api.woa.com/mock/32'
  if (env === 'testing') {
    url = 'https://testprize.sparta.html5.qq.com'
  } else if (env === 'pre') {
    url = 'https://preprize.sparta.html5.qq.com'
  } else if (env === 'production') {
    url = 'https://api.prize.qq.com'
  }

  return url
})()

export const urlPrefix = (() => {
  let url = 'http://local.qq.com:8080'
  if (env === 'testing') {
    url = 'https://testgh.sparta.html5.qq.com'
  } else if (env === 'pre') {
    url = 'https://pre-gh.prize.qq.com'
  } else if (env === 'production') {
    url = 'https://gh.prize.qq.com'
  }

  return url
})()
